import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-dollar",
  templateUrl: "./med-icon-dollar.component.html",
})
export class MedIconDollarComponent extends SvgMixinComponent {}
